import React, { useContext, useState } from 'react';
import Input from '../../Input';
import { maskZip } from '../../../Utils/masks';
import { ContextGetMeuPerfil } from '../../../services/getMeuPerfil';
import { Spinner } from '../../StyledComponent';

const CEPInput = ({
  width,
  disabled,
  value,
  setValue,
  userData,
  setIsErrorApiCep,
  isErrorApiCep,
  validate,
  valid,
}) => {
  const { getEnderecoPorCep } = useContext(ContextGetMeuPerfil);
  const [isLoading, setIsLoading] = useState(false);

  function getAddressByCep(Cep) {
    (async function () {
      if (Cep) {
        setIsLoading(true);
        const result = await getEnderecoPorCep(Cep?.replace('-', ''));

        if (!result?.erro) {
          setIsErrorApiCep(false);

          const {
            logradouro: Logradouro,
            bairro: Bairro,
            localidade: Cidade,
            uf: Estado,
          } = result;

          setValue({
            ...userData,
            Enderecos: [
              {
                ...userData?.Enderecos[0],
                Cep,
                Logradouro,
                Bairro,
                Cidade,
                Estado,
              },
            ],
          });
        } else {
          setIsErrorApiCep(true);

          setValue({
            ...userData,
            Enderecos: [
              {
                ...userData?.Enderecos[0],
                Cep,
                Logradouro: '',
                Bairro: '',
                Cidade: '',
                Estado: '',
                Complemento: '',
                Numero: '',
              },
            ],
          });
        }

        setIsLoading(false);
      }
    })();
  }

  function handleSetValue(event) {
    const Cep = maskZip(event.currentTarget.value);

    setValue({
      ...userData,
      Enderecos: [
        {
          ...userData?.Enderecos[0],
          Cep,
        },
      ],
    });

    if (Cep.length === 9) {
      getAddressByCep(Cep);
      validate(event);
      console.log('event', event.target.value);
    }
  }

  function renderLoading() {
    return <Spinner />;
  }

  return (
    <Input
      id={'Cep'}
      labelName={'Cep'}
      size={width}
      disabled={disabled || isLoading}
      value={value}
      marginTop={0}
      handleInputChange={handleSetValue}
      RightIcon={isLoading && renderLoading}
      error={isErrorApiCep || valid === false}
      errorMessage={
        isErrorApiCep && valid !== false
          ? 'Erro ao consultar o cep, por favor digite o endereço'
          : 'Digite um cep válido'
      }
      onBlur={validate}
    />
  );
};

export default CEPInput;
